import "./App.css";
import DeleteAccount from "./DeleteAccount";
import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

function Delete() {
  const [afterLogin, setAfterLogin] = useState(false);
  const [clientInfo, setClientInfo] = useState([]);
  const [checked, setChecked] = useState(false);
  const [onPrecess, setOnProcess] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const signIn = async () => {
    if (!email || !password) {
      Swal.fire({
        html: `<div>잘못된 이메일/비밀번호 입니다!</div>`,
      });
    }
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/signin`,
      {
        email: email,
        password: password,
      },
      {
        credentials: "same-origin",
        withCredentials: true,
      },
    );
    if (res.data.success) {
      Swal.fire({
        html: `<div>${res.data.message}</div>`,
      });
      setEmail("");
      setPassword("");
      setAfterLogin(true);
    } else {
      Swal.fire({
        html: `<div>${res.data.message}</div>`,
      });
    }
    console.log("res.data ++++++++++++++++++++++++++++++++++++ ");
    console.log(res.data);
    console.log("res.data ------------------------------------ ");
  };

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
        }}
      >
        {afterLogin ? (
          <div>
            <DeleteAccount
              setOnProcess={(value) => {
                setOnProcess(value);
              }}
              setAfterLogin={setAfterLogin}
              checked={checked}
              setChecked={() => {
                setChecked(!checked);
              }}
            />
          </div>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                padding: "0 0 50px 0",
                fontSize: 36,
              }}
            >
              To delete your account, Please login to continue
            </div>
            <div
              style={{
                width: "200px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <label>이메일</label>
                <input
                  type={"email"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <br />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <label>암호</label>
                <input
                  type={"password"}
                  onKeyUp={(keyEvent) => {
                    if (keyEvent.key === "Enter") {
                      signIn();
                    }
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <button onClick={signIn}>로그인</button>
              </div>
            </div>
          </div>
        )}
      </div>
      {onPrecess && (
        <div
          style={{
            position: "absolute",
            width: "100vw",
            height: "100vh",
            background: "black",
            opacity: 0.7,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#FFFFFF",
              fontSize: 64,
            }}
          >
            Deleting Account ......
          </div>
        </div>
      )}
    </div>
  );
}

export default Delete;
